import firebase from "firebase";
import { db } from "./firebase";

const REGISTRATIONS = "registrations";
const LOCATIONS = "locations";

export const saveRegistrationForm = (data, info) => {
  return new Promise((resolve, reject) => {
    db.collection(REGISTRATIONS)
      .add({
        ...data,
        ...info,
        created: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then((doc) => resolve(doc.id))
      .catch((e) => reject(e));
  });
};

export const getDistricts = () => {
  return new Promise((resolve, reject) => {
    db.collection(LOCATIONS)
      .get()
      .then((snapshot) => {
        let data = [];
        if (!snapshot.empty) {
          data = snapshot.docs;
        }
        resolve(data);
      })
      .catch((e) => reject(e));
  });
};
export const getUserName = async (id) => {
  return new Promise((resolve, reject) => {
    db.doc("workers/" + id)
      .get()
      .then((snapshot) => {
        let data;
        if (
          snapshot.data() &&
          (snapshot.data().firstName || snapshot.data().lastName)
        )
          data =
            snapshot.data().firstName +
            " " +
            (snapshot.data().lastName ? snapshot.data().lastName : "");
        resolve(data);
      })
      .catch((e) => reject(e));
  });
};
